import { AnimatePresence, motion } from 'framer-motion';
import React, { useState, useEffect, useRef } from 'react';
import Button from '../buttons/button.component';
import SvgIcon from '../svg-icon/svg-icon.component';
import './dropdown.scss';

const Dropdown = ({
	data,
	onChange,
	name,
	value,
	dataKey,
	dataName,
	allowSelectNone,
	noneSelectionTitle = 'All',
	triggerOnChangeOnInitialise,
	showAddButton,
	className,
}) => {
	const [state, setState] = useState({
		isOpen: false,
		selectedItem: {}, // value ? data.filter((item) => parseInt(item[dataKey]) === value)[0] : data[0],
	});
	const [dropData, setDropData] = useState(data);
	const [searchString, setSearchString] = useState('');

	const node = useRef();

	const toggleDropdown = () => {
		setSearchString('');
		setState({
			...state,
			isOpen: !state.isOpen,
		});
	};

	const selectItem = (item) => {
		setSearchString('');
		setState({
			isOpen: false,
			selectedItem: item,
		});
	};

	const handleClickOutside = (e) => {
		if (node.current.contains(e.target)) {
			// inside click
			return;
		}
		// outside click
		setState({
			...state,
			isOpen: false,
		});
	};

	const onSearch = (e) => {
		console.log(dropData);
		setSearchString(e.target.value);

		console.log(dropData.filter((item) => item[dataName].toLowerCase().includes(searchString)));
	};

	useEffect(() => {
		if (state.isOpen) {
			document.addEventListener('mousedown', handleClickOutside);
		} else {
			document.removeEventListener('mousedown', handleClickOutside);
		}

		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [state.isOpen]);

	useEffect(() => {
		if (!value) return;

		if (value != state.selectedItem[dataKey]) {
			let item = dropData.filter((item) => item[dataKey] === value)[0];

			/* if (item) selectItem(item);
			if (!item) selectItem(dropData[0]); */
			if (item)
				setState({
					isOpen: false,
					selectedItem: item,
				});

			if (!item) {
				selectItem(dropData[0]);
				onChange({
					target: { type: 'text', name: name, value: dropData[0][dataKey] },
				});
			}
		}
	}, [value]);

	useEffect(() => {
		//on init
		let newData = [...dropData];

		if (allowSelectNone) {
			newData.unshift({ [dataKey]: -1, [dataName]: noneSelectionTitle });
			setDropData([...newData]);
		}

		if (!value && data) {
			selectItem(newData[0]);

			if (triggerOnChangeOnInitialise) {
				onChange({
					target: { type: 'text', name: name, value: newData[0][dataKey] },
				});
			}
		}

		if (value && data && triggerOnChangeOnInitialise) {
			let item = dropData.filter((item) => item[dataKey] === value)[0];
			selectItem(item);

			onChange({
				target: { type: 'text', name: name, value: item[dataKey] },
			});
		}
	}, []);

	return (
		<div ref={node} className={`dropdown ${className} ${state.isOpen ? 'open' : ''}`}>
			<div
				className="dropdown-header"
				onClick={() => {
					toggleDropdown();
				}}
			>
				<div className="title">{state?.selectedItem?.[dataName]}</div>
				{/* <svg className={`icon-ios-arrow-down ${state.isOpen ? 'open' : ''} `}>
                    <use xlinkHref="/icons.svg#icon-ios-arrow-down" />
                </svg> */}
				<SvgIcon icon="icon-angle-left" />
			</div>
			<AnimatePresence>
				{state.isOpen && (
					<motion.div
						initial={{ opacity: 0, y: -20 }}
						animate={{ opacity: 1, y: 0 }}
						exit={{ opacity: 0, y: -20 }}
						className="dropdown-list"
					>
						<div className="upper">
							{showAddButton && <Button title="Add new" className="add" icon="plus" onClick={showAddButton} />}

							<input type="text" name="search" placeholder="Search" onChange={onSearch} autoComplete="off" />
						</div>

						<div className="itemList">
							{dropData
								.filter((item) => item[dataName].toLowerCase().includes(searchString))
								.map((item) => {
									return (
										<li
											className={`dropdown-item ${item[dataKey] === state?.selectedItem[dataKey] ? 'selected' : ''}`}
											key={item[dataKey]}
											onClick={(e) => {
												selectItem(item);
												onChange({
													target: { type: 'text', name: name, value: item[dataKey] },
												});
											}}
										>
											{item[dataName]}
										</li>
									);
								})}
						</div>
					</motion.div>
				)}
			</AnimatePresence>
		</div>
	);
};

export default Dropdown;
